// ══════════════════════════════════════════════════════
import { reconcileCoaDocumentLinks } from '../services/coa-migration.js'

// PeptideVault v6.5 — COAs as First-Class Records (Build Note #7)
// Link Certificates of Analysis to lots, vendors, orders, inventory.
// ══════════════════════════════════════════════════════

var _coaView = 'list'     // 'list' | 'detail'
var _coaDetailId = null
var _coaFilter = 'all'    // 'all' | vendor ID
var _coaListScrollTop = 0

function setCoaView(view) { _coaView = view; render() }
function showCoaDetail(coaId) {
  if (_coaView === 'list') _coaListScrollTop = document.querySelector('.main')?.scrollTop || 0
  _coaDetailId = coaId; _coaView = 'detail'; S._scrollToTop = true; render()
}
function setCoaFilter(f) { _coaFilter = f; S._scrollToTop = true; render() }
function backToCoaList() {
  _coaView = 'list'; _coaDetailId = null
  S._listScrollTop = _coaListScrollTop; S._restoreListScroll = true; render()
}

function coaLinkedSkus(coa) {
  var matches = []
  ;(coa && coa.lotIds || []).forEach(function(lotId) {
    ;(S.peptides || []).forEach(function(peptide) {
      ;(peptide.skus || []).forEach(function(sku) {
        if (sku.id === lotId || sku.lotNumber === lotId) matches.push({ peptide: peptide, sku: sku })
      })
    })
  })
  return matches
}

function coaSkuName(coa) {
  var names = coaLinkedSkus(coa).map(function(link) {
    return link.sku.name || link.sku.barcode || link.sku.lotNumber || link.sku.id
  }).filter(Boolean)
  names = names.filter(function(name, index) { return names.indexOf(name) === index })
  return names.length ? names.join(' · ') : (coa.reportNo || 'Unlinked COA')
}

function openCoaRecord(coaId) {
  _coaDetailId = coaId
  _coaView = 'detail'
  setTab('coas')
}

function openCoaForSku(skuId, lotNumber) {
  var coa = getCoasForLot(skuId, lotNumber)[0]
  if (!coa) return showToast('No COA is linked to this SKU')
  openCoaRecord(coa.id)
}

function renderCoasTab() {
  if (_coaView === 'detail' && _coaDetailId) {
    return renderCoaDetail(_coaDetailId)
  }
  return renderCoaList()
}

function renderCoaList() {
  var coas = (S.coas || []).slice()
  if (_coaFilter === 'review') {
    coas = coas.filter(function(c) { return c.migrationStatus === 'needs-review' || (c.documentId && !(S.documents || []).some(function(d) { return d.id === c.documentId })) })
  } else if (_coaFilter && _coaFilter !== 'all') {
    coas = coas.filter(function(c) { return c.vendorId === _coaFilter })
  }
  // Sort by testDate desc, then createdAt desc
  coas.sort(function(a, b) {
    var da = a.testDate || a.createdAt || ''
    var db = b.testDate || b.createdAt || ''
    return String(db).localeCompare(String(da)) || String(a.id).localeCompare(String(b.id))
  })

  // Unique vendors that have COAs
  var vendorIds = {}
  ;(S.coas || []).forEach(function(c) { if (c.vendorId) vendorIds[c.vendorId] = true })
  var vendorsWithCoas = (S.vendors || []).filter(function(v) { return vendorIds[v.id] })
  var total = (S.coas || []).length
  var linked = (S.coas || []).filter(function(c) { return c.documentId }).length
  var needsReview = (S.coas || []).filter(function(c) { return c.migrationStatus === 'needs-review' }).length
  var missingDocs = (S.coas || []).filter(function(c) { return c.documentId && !(S.documents || []).some(function(d) { return d.id === c.documentId }) }).length

  return '<div class="tab-content coa-page">' +
    '<div class="row" style="margin-bottom:16px;flex-wrap:wrap;gap:8px;align-items:center">' +
      '<h2 style="font-size:20px;font-weight:700">Certificates of Analysis</h2>' +
      '<div class="spacer"></div>' +
      (vendorsWithCoas.length > 0 ? '<select class="form-input" style="width:auto;font-size:12px" onchange="setCoaFilter(this.value)">' +
        '<option value="all"' + (_coaFilter === 'all' ? ' selected' : '') + '>All Vendors</option>' +
        '<option value="review"' + (_coaFilter === 'review' ? ' selected' : '') + '>Needs Review</option>' +
        vendorsWithCoas.map(function(v) {
          return '<option value="' + v.id + '"' + (_coaFilter === v.id ? ' selected' : '') + '>' + esc(v.name) + '</option>'
        }).join('') +
      '</select>' : '') +
      '<button class="btn btn-secondary" onclick="reconcileCoaLinksNow()">Reconcile SKU Links</button>' +
      '<button class="btn btn-primary" onclick="openModal(\'addCoa\')">' + ICONS.plus + ' Add COA</button>' +
    '</div>' +

    '<div style="display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:10px;margin-bottom:14px">' +
      coaMetric('Total COAs', total) + coaMetric('Documents Linked', linked) +
      coaMetric('Needs Review', needsReview) + coaMetric('Missing Documents', missingDocs) +
    '</div>' +

    (coas.length === 0 ?
      '<div class="card"><div class="empty-state" style="padding:48px">' +
        '<div class="empty-icon">\uD83D\uDCDC</div>' +
        '<p>No Certificates of Analysis yet</p>' +
        '<span>Add COAs to track test results for your peptide lots and link them to vendors and orders.</span>' +
      '</div></div>' :

      coas.map(function(coa) {
        var vendor = (S.vendors || []).find(function(v) { return v.id === coa.vendorId })
        var lotCount = (coa.lotIds || []).length
        var resultCount = (coa.results || []).length
        var purityResult = (coa.results || []).find(function(r) { return (r.testName || '').toLowerCase().indexOf('purity') >= 0 })

        return '<div class="card" style="margin-bottom:10px;cursor:pointer" onclick="showCoaDetail(\'' + coa.id + '\')">' +
          '<div class="card-header">' +
            '<div>' +
              '<div class="card-title">' + esc(coaSkuName(coa)) + '</div>' +
              '<div style="font-size:12px;color:var(--text3)">' +
                (vendor ? esc(vendor.name) : '<span style="color:var(--text4)">No vendor</span>') +
                (coa.testLab ? ' \u00B7 Lab: ' + esc(coa.testLab) : '') +
                (coa.testDate ? ' \u00B7 ' + fmt(coa.testDate) : '') +
              '</div>' +
            '</div>' +
            '<div class="row" style="gap:6px">' +
              (purityResult ? '<span class="badge badge-green">' + esc(purityResult.value) + (purityResult.unit ? ' ' + esc(purityResult.unit) : '') + ' purity</span>' : '') +
              (coa.migrationStatus === 'needs-review' ? '<span class="badge badge-yellow">Needs review</span>' : '') +
              (lotCount > 0 ? '<span class="badge">' + lotCount + ' lot' + (lotCount > 1 ? 's' : '') + '</span>' : '') +
              '<span class="badge">' + resultCount + ' test' + (resultCount > 1 ? 's' : '') + '</span>' +
            '</div>' +
          '</div>' +
        '</div>'
      }).join('')
    ) +
  '</div>'
}

function coaMetric(label, value) {
  return '<div class="card" style="padding:12px"><div style="font-size:20px;font-weight:700">' + value + '</div><div style="font-size:11px;color:var(--text3)">' + label + '</div></div>'
}

function renderCoaDetail(coaId) {
  var coa = (S.coas || []).find(function(c) { return c.id === coaId })
  if (!coa) return '<div class="tab-content"><div class="card" style="padding:24px;text-align:center">COA not found</div></div>'

  var vendor = (S.vendors || []).find(function(v) { return v.id === coa.vendorId })
  var doc = coa.documentId ? (S.documents || []).find(function(d) { return d.id === coa.documentId }) : null

  // Find linked lots
  var linkedLots = []
  ;(coa.lotIds || []).forEach(function(lotId) {
    ;(S.peptides || []).forEach(function(pep) {
      ;(pep.skus || []).forEach(function(sku) {
        if (sku.id === lotId || sku.lotNumber === lotId) {
          linkedLots.push({ peptideName: pep.name, peptideId: pep.id, sku: sku })
        }
      })
    })
  })

  return '<div class="tab-content coa-page">' +
    '<div class="row" style="margin-bottom:16px;gap:8px;align-items:center">' +
      '<button class="btn btn-ghost btn-sm" onclick="backToCoaList()">\u2190 Back</button>' +
      '<div><h2 style="font-size:20px;font-weight:700">' + esc(coaSkuName(coa)) + '</h2>' +
      (coa.reportNo ? '<div style="font-size:12px;color:var(--text3)">Report ' + esc(coa.reportNo) + '</div>' : '') + '</div>' +
      '<div class="spacer"></div>' +
      (doc ? '<button class="btn btn-primary btn-sm" onclick="openDocFile(getDoc(\'' + doc.id + '\'))">' + ICONS.eye + ' View PDF</button>' : '') +
      '<button class="btn btn-secondary btn-sm" onclick="openModal(\'editCoa\',{coaId:\'' + coa.id + '\'})">' + ICONS.edit + ' Edit</button>' +
      '<button class="btn btn-danger btn-sm" onclick="deleteCoa(\'' + coa.id + '\')">' + ICONS.trash + ' Delete</button>' +
    '</div>' +

    // Info grid
    '<div style="display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-bottom:16px">' +
      '<div class="card" style="padding:14px">' +
        '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:8px">Certificate Info</div>' +
        '<div style="font-size:13px;line-height:1.8">' +
          '<div><span style="color:var(--text3)">Report #:</span> <b>' + esc(coa.reportNo || '\u2014') + '</b></div>' +
          '<div><span style="color:var(--text3)">Test Lab:</span> ' + esc(coa.testLab || '\u2014') + '</div>' +
          '<div><span style="color:var(--text3)">Test Date:</span> ' + (coa.testDate ? fmt(coa.testDate) : '\u2014') + '</div>' +
          '<div><span style="color:var(--text3)">Vendor:</span> ' + (vendor ? esc(vendor.name) : '\u2014') + '</div>' +
          (coa.orderId ? '<div><span style="color:var(--text3)">Order ID:</span> ' + esc(coa.orderId) + '</div>' : '') +
          '<div><span style="color:var(--text3)">Created:</span> ' + (coa.createdAt ? fmt(coa.createdAt) : '\u2014') + '</div>' +
        '</div>' +
      '</div>' +

      '<div class="card" style="padding:14px">' +
        '<div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:8px">Linked Items</div>' +
        // Linked lots
        (linkedLots.length > 0 ?
          '<div style="margin-bottom:8px">' +
            linkedLots.map(function(ll) {
              return '<div style="font-size:12px;padding:4px 0;border-bottom:1px solid var(--border2)">' +
                '<span style="font-weight:600">' + esc(ll.peptideName) + '</span>' +
                ' <span style="color:var(--text3)">Lot: ' + esc(ll.sku.lotNumber || ll.sku.id) + '</span>' +
                (ll.sku.vendor ? ' \u00B7 ' + esc(ll.sku.vendor) : '') +
                ' <a style="color:var(--accent);font-size:11px;cursor:pointer" onclick="event.stopPropagation();S.tab=\'peptides\';S.selectedPeptide=\'' + ll.peptideId + '\';render()">View \u2192</a>' +
              '</div>'
            }).join('') +
          '</div>' :
          '<div style="font-size:12px;color:var(--text4)">No lots linked</div>'
        ) +
        // PDF belongs to this COA catalog record (the backing document stays internal).
        (doc ? '<div style="margin-top:8px"><span style="font-size:11px;color:var(--text3)">COA PDF:</span> <button class="btn btn-secondary btn-xs" style="margin-left:6px" onclick="event.stopPropagation();openDocFile(getDoc(\'' + doc.id + '\'))">' + ICONS.eye + ' View PDF</button></div>' :
          (coa.documentId ? '<div style="margin-top:8px;color:var(--red);font-size:12px">Linked document is missing</div>' : '')) +
      '</div>' +
    '</div>' +

    // Test results table
    '<div class="card" style="padding:0;overflow:hidden">' +
      '<div style="padding:10px 14px;background:var(--bg3);border-bottom:1px solid var(--border2);font-size:13px;font-weight:600">Test Results</div>' +
      ((coa.results || []).length === 0 ?
        '<div style="padding:20px;text-align:center;color:var(--text4);font-size:12px">No test results recorded</div>' :
        '<table style="width:100%;border-collapse:collapse;font-size:13px">' +
          '<thead><tr style="border-bottom:1px solid var(--border)">' +
            '<th style="padding:8px 14px;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Test</th>' +
            '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Result</th>' +
            '<th style="padding:8px 14px;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Specification</th>' +
            '<th style="padding:8px 14px;text-align:center;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Status</th>' +
          '</tr></thead>' +
          '<tbody>' +
          (coa.results || []).map(function(r) {
            var pass = r.pass !== false
            var reportedOnly = r.pass === null
            return '<tr style="border-bottom:1px solid var(--border2)">' +
              '<td style="padding:8px 14px;font-weight:500">' + esc(r.testName || '') + '</td>' +
              '<td style="padding:8px 14px;text-align:right;font-weight:600">' + esc(r.value || '') + (r.unit ? ' ' + esc(r.unit) : '') + '</td>' +
              '<td style="padding:8px 14px;text-align:right;color:var(--text3)">' + esc(r.specification || '\u2014') + '</td>' +
              '<td style="padding:8px 14px;text-align:center">' +
                (reportedOnly ? '<span style="color:var(--text3)">Reported</span>' : pass ? '<span style="color:var(--green)">\u2713 Pass</span>' : '<span style="color:var(--red)">\u2717 Fail</span>') +
              '</td>' +
            '</tr>'
          }).join('') +
          '</tbody></table>'
      ) +
    '</div>' +

    // Notes
    (coa.notes ? '<div class="card" style="margin-top:12px;padding:14px"><div style="font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase;margin-bottom:4px">Notes</div><div style="font-size:13px;white-space:pre-wrap">' + esc(coa.notes) + '</div></div>' : '') +
  '</div>'
}

// ══════════════════════════════════════════════════════
// COA linked views for peptide detail
// ══════════════════════════════════════════════════════

function getCoasForPeptide(peptideId) {
  var peptide = (S.peptides || []).find(function(p) { return p.id === peptideId })
  if (!peptide) return []
  var skuIds = (peptide.skus || []).map(function(s) { return s.id })
  var lotNums = (peptide.skus || []).map(function(s) { return s.lotNumber }).filter(Boolean)
  return (S.coas || []).filter(function(coa) {
    return (coa.lotIds || []).some(function(lid) {
      return skuIds.indexOf(lid) >= 0 || lotNums.indexOf(lid) >= 0
    })
  })
}

function getCoasForLot(skuId, lotNumber) {
  var sku = null
  ;(S.peptides || []).some(function(p) {
    sku = (p.skus || []).find(function(s) { return s.id === skuId }) || null
    return !!sku
  })
  var docIds = sku ? (sku.coaDocIds || []).concat(sku.coaDocId ? [sku.coaDocId] : []) : []
  return (S.coas || []).filter(function(coa) {
    return (coa.lotIds || []).some(function(lid) {
      return lid === skuId || lid === lotNumber
    }) || (coa.documentId && docIds.indexOf(coa.documentId) >= 0)
  })
}

function renderCoaBadges(peptideId) {
  var coas = getCoasForPeptide(peptideId)
  if (coas.length === 0) return ''
  return '<span class="badge" style="cursor:pointer" onclick="event.stopPropagation();setTab(\'coas\')">\uD83D\uDCDC ' + coas.length + ' COA' + (coas.length > 1 ? 's' : '') + '</span>'
}

// ══════════════════════════════════════════════════════
// COA SAVE / DELETE HANDLERS
// ══════════════════════════════════════════════════════

function saveCoaFromModal(existingId) {
  var vendorId = (document.getElementById('coa-vendor') || {}).value || ''
  var reportNo = (document.getElementById('coa-reportno') || {}).value || ''
  var testLab = (document.getElementById('coa-testlab') || {}).value || ''
  var testDate = (document.getElementById('coa-testdate') || {}).value || ''
  var orderId = (document.getElementById('coa-orderid') || {}).value || ''
  var notes = (document.getElementById('coa-notes') || {}).value || ''
  var documentId = (document.getElementById('coa-document') || {}).value || ''

  // Gather lot selections (multi-select)
  var lotChecks = document.querySelectorAll('.coa-lot-check:checked')
  var lotIds = []
  lotChecks.forEach(function(cb) { lotIds.push(cb.value) })

  // Gather test result rows
  var resultRows = document.querySelectorAll('.coa-result-row')
  var results = []
  resultRows.forEach(function(row) {
    var testName = (row.querySelector('[data-result-name]') || {}).value || ''
    var value = (row.querySelector('[data-result-value]') || {}).value || ''
    var unit = (row.querySelector('[data-result-unit]') || {}).value || ''
    var specification = (row.querySelector('[data-result-spec]') || {}).value || ''
    var pass = (row.querySelector('[data-result-pass]') || {}).checked !== false
    if (testName || value) {
      results.push({ testName: testName, value: value, unit: unit, specification: specification, pass: pass })
    }
  })

  if (existingId) {
    var coa = (S.coas || []).find(function(c) { return c.id === existingId })
    if (coa) {
      coa.vendorId = vendorId
      coa.reportNo = reportNo
      coa.testLab = testLab
      coa.testDate = testDate
      coa.orderId = orderId
      coa.lotIds = lotIds
      coa.results = results
      coa.notes = notes
      coa.documentId = documentId
      coa.migrationStatus = 'reviewed'
    }
  } else {
    S.coas.push({
      id: uid(),
      vendorId: vendorId,
      lotIds: lotIds,
      orderId: orderId,
      documentId: documentId,
      testLab: testLab,
      reportNo: reportNo,
      testDate: testDate,
      results: results,
      notes: notes,
      source: 'manual',
      migrationStatus: 'reviewed',
      createdAt: now()
    })
  }
  save()
  closeModal()
  showToast(existingId ? 'COA updated' : 'COA added')
}

function reconcileCoaLinksNow() {
  var result = reconcileCoaDocumentLinks(S, uid, now)
  save(); render()
  showToast(result.created ? 'Created ' + result.created + ' COA records from SKU links' : 'COA links are up to date')
}

function deleteCoa(coaId) {
  if (!confirm('Delete this COA?')) return
  S.coas = (S.coas || []).filter(function(c) { return c.id !== coaId })
  save()
  backToCoaList()
  showToast('COA deleted')
}

function addCoaResultRow() {
  var container = document.getElementById('coa-results-container')
  if (!container) return
  var html = '<div class="coa-result-row" style="display:grid;grid-template-columns:2fr 1fr 1fr 2fr auto auto;gap:6px;align-items:end;margin-bottom:6px">' +
    '<div class="form-group"><label style="font-size:11px">Test Name</label><input class="input" style="font-size:12px" data-result-name placeholder="e.g. Purity"></div>' +
    '<div class="form-group"><label style="font-size:11px">Result</label><input class="input" style="font-size:12px" data-result-value placeholder="98.5"></div>' +
    '<div class="form-group"><label style="font-size:11px">Unit</label><input class="input" style="font-size:12px" data-result-unit placeholder="%"></div>' +
    '<div class="form-group"><label style="font-size:11px">Specification</label><input class="input" style="font-size:12px" data-result-spec placeholder="\u2265 95%"></div>' +
    '<div class="form-group"><label style="font-size:11px">Pass</label><input type="checkbox" data-result-pass checked style="margin-top:6px"></div>' +
    '<button class="btn btn-ghost btn-xs" onclick="this.closest(\'.coa-result-row\').remove()" style="color:var(--red);margin-bottom:6px">\u2715</button></div>'
  container.insertAdjacentHTML('beforeend', html)
}

// Create COA pre-linked to a specific lot
function createCoaFromLot(peptideId, skuId) {
  openModal('addCoa', { preLinkedLotId: skuId, preLinkedPeptideId: peptideId })
}

export {
  _coaView,
  _coaDetailId,
  _coaFilter,
  setCoaView,
  showCoaDetail,
  setCoaFilter,
  backToCoaList,
  renderCoasTab,
  renderCoaList,
  renderCoaDetail,
  getCoasForPeptide,
  getCoasForLot,
  renderCoaBadges,
  saveCoaFromModal,
  deleteCoa,
  addCoaResultRow,
  createCoaFromLot,
  reconcileCoaLinksNow,
  coaLinkedSkus,
  coaSkuName,
  openCoaRecord,
  openCoaForSku
}
